import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=cb3d249a&"
import script from "./MsgList.vue?vue&type=script&lang=js&"
export * from "./MsgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports